module.exports = __webpack_public_path__ + "static/googledrive-22498f7d316a8fbdfff007c4a38f0ea1.svg";